import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects Google Ads / GA4 / Meta Pixel scripts if configured by admin.
export const AnalyticsInjector = () => {
  useEffect(() => {
    let cancelled = false;
    if (typeof localStorage !== "undefined" && localStorage.getItem("wth_cookie_consent") !== "accepted") return;
    api.get("/site/settings").then(({ data }) => {
      if (cancelled) return;
      const { ga4_id, google_ads_id, meta_pixel_id } = data || {};
      if (ga4_id || google_ads_id) {
        const id = ga4_id || google_ads_id;
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(s);
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;
        gtag("js", new Date());
        if (ga4_id) gtag("config", ga4_id);
        if (google_ads_id) gtag("config", google_ads_id);
      }
      if (meta_pixel_id && meta_pixel_id !== "null") {
        /* eslint-disable */
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
          if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
          t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        window.fbq("init", meta_pixel_id);
        window.fbq("track", "PageView");
        /* eslint-enable */
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
};
